<template>
  <div class="selecter">
    <select
      :class="{inactive:!active , 'selecter__alert':alert }"
      v-model="value"
      @change="updateSelect"
      v-if="simpleList"
    >
      <option
        v-if="placeholder"
        disabled
        value
      >
        {{ placeholder }}
      </option>
      <option
        v-for="(item, index) in listFromStore"
        :key="index"
        :value="item"
        :selected="item.selected"
      >
        {{ item }}
      </option>
    </select>
    <select
      :class="{inactive:!active , 'selecter__alert':alert }"
      v-model="value"
      @change="updateSelect"
      v-else
    >
      <option
        v-if="placeholder"
        disabled
        value
      >
        {{ placeholder }}
      </option>
      <option
        v-for="(item, index) in listFromStore"
        :key="index"
        :value="item.value"
        :selected="item.selected"
      >
        {{ item.label }}
      </option>
    </select>
    <i
      v-if="svg"
      :class="{'selecter__svg--rotate': svg === '#icon-arrow2'}"
      class="selecter__svg"
    >
      <svg>
        <use :xlink:href="svg"></use>
      </svg>
    </i>
  </div>
</template>
<script>
export default {
  name: 'Selecter',
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    alert: {
      type: Boolean,
      default: false,
    },
    svg: {
      type: String,
      default: '',
    },
    listFromStore: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    selected: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    simpleList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: '',
      list: [],
    }
  },

  mounted() {
    this.setDefaultValue()
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.value = newVal
      }
    },
  },
  methods: {
    updateSelect(event) {
      const select = {
        name: this.name,
        value: event.target.value,
      }
      return this.$emit('item', select)
    },
    setDefaultValue() {
      this.value = this.selected || ''
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.selecter {
  @include shared-svg-inputs;

  align-items: normal;

  i {
    pointer-events: none;
    top: auto;
  }

  &__alert {
    @include alert;
  }

  &__svg {
    &--rotate {
      svg {
        @include rotate(90deg);
      }
    }
  }

  select {
    @include sharable-input;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // background-color: white;
    border-radius: 0;
    padding: 0;
    text-align: center;
    width: 100%;

    .inactive & {
      color: $c-edward;
    }
  }

  /* CAUTION: IE hackery ahead */
  select::-ms-expand {
    display: none; /* remove default arrow on ie10 and ie11 */
  }

  /* target Internet Explorer 9 to undo the custom arrow */
  @media screen and (min-width: 0\0) {
    select {
      background: none\9;
      padding: 5px\9;
    }
  }
}
</style>
